.modal-scrollable {
  padding: var(--rc-theme-react-components-modal-scrollable-padding-lg);

  .modal-scrollable--item-sticky {
    position: sticky;
    z-index: 1;
    background-color: var(--rc-theme-color-surface-default);
  }

  &.modal-scrollable--padding-bottom-0 {
    padding-bottom: 0;
  }

  &.modal-scrollable--padding-top-0 {
    padding-top: 0;
  }
}
